import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { convertToFixedDecimal } from 'core-lib/utils/helpers';
import { getDefaultHeaders } from 'core-lib/utils/network';
import { isServer } from 'core-lib/utils/utils';
import { setImageUrl } from 'shop/utils/helper';
import Layout from '../../types/layout';
import Product from '../../types/product';

export const serializeProduct: (item: any) => Product = (item: any) => {
  const coverImage =
    setImageUrl(item?.cover_image ?? item?.img_url, 2) ??
    setImageUrl(item?.image, 1);
  return {
    productId: item?.id ?? item?.product_id,
    productSku: item?.sku,
    productType: item?.product_type,
    skuType: item?.sku_type,
    price: convertToFixedDecimal(item?.price ?? 0, 0) as number, // mrp
    discountedPrice: convertToFixedDecimal(
      item?.discounted_price ?? 0,
      2
    ) as number, // price at which the product is sold without lp
    loyaltyPoints: convertToFixedDecimal(
      item?.loyalty_points_for_discount ?? 0,
      0
    ) as number, // loyalty points applicable
    loyaltyPrice: convertToFixedDecimal(item?.loyalty_price ?? 0, 2) as number, // price after applying loyalty points
    stock: item?.stock_item?.is_in_stock ? item?.stock_item?.qty ?? 0 : 0, // actual stock
    virtualStock: item?.virtual_stock || 100, // stock to be shown to customer
    icon: setImageUrl(item?.icon ?? item?.icon, 1),
    // @TODO: ask be to correct item?.img_url
    coverImage,
    title: item?.title,
    actualDiscountedPrice: item?.actual_discounted_price,
    subtitle1: item?.subtitle1,
    subtitle2: item?.subtitle2,
    totalVotes: item?.total_votes,
    offerText: item?.brand_offer,
    tag: item?.tag,
    priceNudge: item?.price_nudge,
    rating: item?.rating,
    filter: item?.filter,
    suffix: item?.suffix,
    redirectionUrl: item?.redirection_url,
    screenId: item?.screenId,
    screenData: item?.screenData,
    productOption: item?.product_option,
    parentId: item?.parent_id,
    videoUrl: item?.video_url,
    brandLogo: item?.brand_logo,
    // @TODO: remove hardcoding
    maxCartQuantity: item?.max_cart_quantity ? +item.max_cart_quantity : 5,
    subCategoryId: item?.sub_category_id,
    eventType: item?.event_type,
    slashPrice: item?.slash_price,
  };
};

const getCardData: (data: any[]) => Product[] = (data) => {
  if (!data) return [];
  return data?.map((item) => serializeProduct(item));
};

export const serializeHomePage = (data) => {
  if (!data) return [];
  const response: Layout[] = data?.map((item) => ({
    layoutId: item?.layout_id,
    layoutType: item?.layout_type,
    entityType: item?.entity_type,
    data: getCardData(item?.data),
    endTime: item?.end_time,
    title: item?.title,
    subtitle: item?.subtitle,
    ctaText: item?.cta_text,
    backgroundImage: item?.background_image,
    votedProductId: item?.voted_product_id,
    backgroundColor: item?.theme,
    textColor: item?.color,
    sectionName: item?.section_name,
    metaData: item?.meta_data && {
      headingImage: item?.meta_data?.heading_image,
      listingOrder: item?.meta_data?.listing_order,
      categories: getCardData(item?.meta_data?.categories),
      autoplay: item?.meta_data?.autoplay ?? false,
      showDrop: item?.meta_data?.show_drop ?? false,
      savings: item.meta_data?.savings,
      subtitle1: item.meta_data?.subtitle1,
      campaignId: item?.meta_data?.campaign_id,
      subtitle2: item.meta_data?.subtitle2,
      videoUrl: item.meta_data?.video_url,
      videoText: item.meta_data?.video_text,
      starIcon: item.meta_data?.star_icon,
      clockWatchIcon: item.meta_data?.clock_watch_icon,
      eventExpiryTime: item?.meta_data?.event_expiry_time,
      slashPriceEndsIn: item.meta_data?.slash_price_ends,
      comeBackTime: item.meta_data?.come_back_time,
    },
  }));
  return response;
};

export const storeHomePage = async (categoryId, page, limit) => {
  const endPoint = `${apiConfig(
    'magento'
  )}/default/V1/custom/homepage/config?category_id=${categoryId}&page=${
    !isNaN(page) ? page : 1
  }&limit=${limit}`;
  const { response, error, status }: any = await getMethod({
    endPoint,
    headers: getDefaultHeaders({ deviceId: false }),
  });
  if (isServer() && status == 401) throw error;

  if (response?.data) {
    return {
      categoryId: response?.category_id,
      data: serializeHomePage(response?.data),
      hasMore: response?.has_more,
      page: page + 1,
    };
  }
};

// const getHomePageData = async () => {
//   const [storeData, mlStoreData] = await Promise.all([
//     storeHomePage(10),
//     storeHomePage(20),
//   ]);

//   //no need as promise.all return data in order in which they are called
//   if (storeData?.categoryId === 10) return [storeData, mlStoreData];

//   return [mlStoreData, storeData];
// };

// export default getHomePageData;
